import React       from "react"
import PropTypes   from "prop-types"
import Grid        from "./Grid"
import { getCodeOrConcept, getPath } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails"
import Period      from "./Period"
import Date        from "./Date"
import moment      from "moment"
import SelectionCheckbox from "./SelectionCheckbox.jsx"
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { gridStyles } from "../../pages/ClaimAnalysisPage/ClaimViewPage/PatientDetails/PatientDetails.tsx";
import { toast } from "react-toastify";

const HARDCODED_PDF_BASE64 =
"JVBERi0xLjQKMSAwIG9iago8PCAvVHlwZSAvQ2F0YWxvZyAvUGFnZXMgMiAwIFIgPj4KZW5kb2JqCjIgMCBvYmoKPDwgL1R5cGUgL1BhZ2VzIC9LaWRzIFszIDAgUl0gL0NvdW50IDEgPj4KZW5kb2JqCjMgMCBvYmoKPDwgL1R5cGUgL1BhZ2UgL1BhcmVudCAyIDAgUiAvTWVkaWFCb3ggWzAgMCA1OTUgODQyXSAvQ29udGVudHMgNCAwIFIgL1Jlc291cmNlcyA8PCAvRm9udCA8PCAvRjEgNSAwIFIgPj4gPj4gPj4KZW5kb2JqCjQgMCBvYmoKPDwgL0xlbmd0aCA3MiA+PgpzdHJlYW0KQlQKL0YxIDI0IFRmCjIwMCA0MjAgVGQKKER1bW15IFJlZmVyZW5jZSBEb2N1bWVudCkgVGoKRVQKZW5kc3RyZWFtCmVuZG9iago1IDAgb2JqCjw8IC9UeXBlIC9Gb250IC9TdWJ0eXBlIC9UeXBlMSAvQmFzZUZvbnQgL0hlbHZldGljYSA+PgplbmRvYmoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmCjAwMDAwMDAwMTAgMDAwMDAgbgowMDAwMDAwMDYxIDAwMDAwIG4KMDAwMDAwMDAxMzAgMDAwMDAgbgowMDAwMDAwMjMwIDAwMDAwIG4KMDAwMDAwMDAzMDAgMDAwMDAgbgp0cmFpbGVyCjw8IC9Sb290IDEgMCBSIC9TaXplIDYgPj4Kc3RhcnR4cmVmCjM4MAolJUVPRg==";


const isDevOrStage =
    window.location.host === "dev.slicedhealth.com" ||
    window.location.host === "staging.slicedhealth.com" ||
    window.location.host.includes("localhost");

    
function renderCell(record, allOf, oneOf) {

    const entries = [];

    const visit = meta => {
        let propValue = getPath(record, meta.path);
        if (propValue !== undefined) {
            let value = meta.render ? meta.render(record) : propValue;
            let raw   = meta.raw ? meta.raw(record) : value;
            let label = typeof meta.label == "function" ? meta.label(record) : meta.label;
            let existing = entries.find(o => o.value === raw);
            if (existing) {
                existing.label += ", " + label
            }
            else {
                entries.push({ label, value });
            }
            return true;
        }
        return false;
    };

    allOf.forEach(visit);

    if (!entries.length) {
        oneOf.some(visit);
    }

    if (entries.length) {
        return (
            <table>
                <tbody>
                    {
                        entries.map((o, i) => (
                            <tr key={i}>
                                <td className="label-cell">{ o.label }</td>
                                <td>{ o.value }</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        );
    }

    return "-"
}

function getSortValue(rec) {
    const paths = [
        "authoredOn",
        "dateWritten",
        "performedDateTime",
        "recorded",
        "performedPeriod.start",
        "availableTime.0.availableStartTime",
        "whenHandedOver",
        "issued",
        "effectiveDateTime",
        "assertedDate",
        "meta.lastUpdated"
    ];

    for (let i = 0, l = paths.length; i < l; i++) {
        let v = getPath(rec, paths[i]);
        if (v !== undefined) {
            return v
        }
    }

    return 0;
}


export default class ResourceList extends React.Component
{
    static propTypes = {
        type     : PropTypes.string,
        resources: PropTypes.arrayOf(PropTypes.object).isRequired,
        settings : PropTypes.object.isRequired,
        onSelectionChange: PropTypes.func,
    };


    getFileExtension = (contentType) => {
        if (!contentType) return "bin";

        const map = {
            "application/pdf": "pdf",
            "application/msword": "doc",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
            "application/vnd.ms-excel": "xls",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
            "text/plain": "txt",
            "text/html": "pdf",
        };
        return map[contentType] || contentType.split("/")[1] || "bin";
    };

    base64ToBlob = (base64, contentType) => {

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        return new Blob([byteArray], { type: contentType });
    };

   printPdfBlob = (blob) => {
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";

        iframe.src = blobUrl;

        document.body.appendChild(iframe);

        iframe.onload = () => {
            const iframeWindow = iframe.contentWindow;

            if (!iframeWindow) return;

            iframeWindow.focus();
            iframeWindow.print();

            iframeWindow.onafterprint = () => {
                document.body.removeChild(iframe);
                URL.revokeObjectURL(blobUrl);
            };
        };
    };

    downloadBlob = (blob, filename) => {

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(url);
    };

    handleDownload = (record) => {
    try{

    const attachment = record?.content?.[0]?.attachment;

    if (!attachment?.data) return;

    if (!attachment.contentType) {
        toast.error("Unknown file type.", {
        autoClose: 3000
    });
        return;
    }

    const base64Data = attachment.data;
    const contentType = attachment.contentType;

    let blob = null;

    //  HTML → Dummy PDF (Temp Logic)
    if (contentType === "text/html") {

        const blob = this.base64ToBlob(
        HARDCODED_PDF_BASE64,
        "application/pdf"
    );

    this.printPdfBlob(blob);
    return;

    }
    if (contentType === "application/pdf") {

        blob = this.base64ToBlob(base64Data, contentType);
    }
    if (blob) {
    this.printPdfBlob(blob);
    return;
}

    const type = contentType;
    const ext = this.getFileExtension(type);

    const fileBlob = this.base64ToBlob(base64Data, type);

    this.downloadBlob(
        fileBlob,
        `document-${record.id || "file"}.${ext}`
    );
    }
    catch (error) {
        console.error("Download error:", error);

        toast.error("Something went wrong while downloading the file.", {
            autoClose: 3000
        });
}

};


    getIdentifierColumnSchema() {
        return {
            label: "Identifier",
            render: o => renderCell(o, [
                {
                    path: "id",
                    label: "ID",
                    ellipsis: 15
                },
                {
                    path: "name",
                    label: "Name"
                },
                {
                    path: "identifier.0.type.coding.0.code",
                    label: "Identifiers",
                    render: rec => {
                        if (Array.isArray(rec.identifier)) {
                            return rec.identifier.map(id => {
                                let code = getPath(id, "type.coding.0.code");
                                if (!code) return null;
                                return code + ": " + id.value;
                            }).filter(Boolean).join(", ")
                        }
                        return "-"
                    }
                }
            ])
        };
    }

    getDetailsColumnSchema() {
        return {
            label: "Details",
            render: o => renderCell(o, [
                {
                    path: "description.text",
                    label: "Description"
                },
                {
                    path: "code.text",
                    label: "Code"
                },
                {
                    path: "code.coding.0.display",
                    label: "Display"
                },
                {
                    path: "medicationCodeableConcept.coding.0.display",
                    label: "Medication"
                },
                {
                    path: "medicationCodeableConcept.coding.0.code",
                    label: rec => (getPath(rec, "medicationCodeableConcept.coding.0.system") || "").split(/\b/).pop()
                },
                {
                    path: "code.coding.0.code",
                    label: rec => ((getPath(rec, "code.coding.0.system") || "")
                        .replace(/\/$/, "").split(/\//).pop() + " code")
                },
                {
                    path: "result.0.display",
                    label: "Result",
                    render: rec => rec.result.map(r => r.display || 0).filter(Boolean).join(", ")
                },
                {
                    label: "Status",
                    render: rec => getCodeOrConcept(rec.status)
                },
                {
                    label: "Clinical Status",
                    render: rec => getCodeOrConcept(rec.clinicalStatus)
                },
                {
                    label: "Verification Status",
                    render: rec => getCodeOrConcept(rec.verificationStatus)
                },
                {
                    label: "Value as String",
                    path: "valueString"
                },
                {
                    label: "Comment",
                    path: "comment"
                },
                {
                    label: "Extra Details",
                    path: "extraDetails"
                },
                {
                    label: "Type",
                    path: "type",
                    render: rec => {
                        if (Array.isArray(rec.type)) {
                            return rec.type.map(t => {
                                return t.text || getPath(t, "coding.0.display") || "";
                            }).filter(Boolean).join(", ")
                        }
                        return String(getPath(rec, "type.coding.0.display") || getPath(rec, "type.text") || rec.type);
                    }
                },
                {
                    label: "Criticality",
                    path: "criticality"
                },
                {
                    label: "Category",
                    path: "category",
                    render: rec => {
                        function renderCategory(c) {
                            if (!c) {
                                return "N/A";
                            }

                            if (typeof c == "string") {
                                return c;
                            }

                            if (Array.isArray(c)) {
                                return c.map(renderCategory).join(", ");
                            }

                            if (typeof c != "object") {
                                return "N/A";
                            }

                            return c.text || c.display || c.code || renderCategory(c.coding);
                        }

                        return renderCategory(rec.category);
                    }
                },
                {
                    label: "Quantity",
                    path: "quantity.value",
                    render: rec => (
                        <span>
                            {rec.quantity.value}
                            <span className="text-muted"> {
                                rec.quantity.unit || rec.quantity.units || ""
                            }</span>
                        </span>
                    )
                },
                {
                    label: "Days Supply",
                    path: "daysSupply.value",
                    render: rec => (
                        <span>
                            {rec.daysSupply.value}
                            <span className="text-muted">&nbsp;{
                                rec.daysSupply.unit || rec.daysSupply.units || ""
                            }</span>
                        </span>
                    )
                },
                {
                    label: "Medication",
                    path: "medicationReference.reference",
                }
            ], [
                {
                    path: "text.div",
                    label: "Text",
                    render: rec => <span dangerouslySetInnerHTML={{ __html: rec.text.div }}/>
                }
            ])
        };
    }
    getDateColumnSchema() {
        return {
            label: "Date",
            render: o => renderCell(o, [
                {
                    path: "authoredOn",
                    label: "Authored On",
                    render: rec => <Date moment={rec.authoredOn}/>
                },
                {
                    path: "dateWritten",
                    label: "Date Written",
                    render: rec => <Date moment={rec.dateWritten}/>
                },
                {
                    path: "performedDateTime",
                    label: "Performed At",
                    render: rec => <Date moment={rec.performedDateTime}/>
                },
                {
                    path: "recorded",
                    label: "Recorded",
                    render: rec => <Date moment={rec.recorded}/>
                },
                {
                    path: "performedPeriod",
                    label: "Performed",
                    render: rec => Period(rec.performedPeriod)
                },
                {
                    path: "availableTime",
                    label: "Available Time",
                    render: rec => {
                        if (Array.isArray(rec.availableTime)) {
                            return rec.availableTime.map((t, i) => (
                                <div key={i}>
                                    { t.availableStartTime && (<span>
                                        <label>from:&nbsp;</label>
                                        <span>{ t.availableStartTime }&nbsp;</span>
                                    </span>) }
                                    { t.availableEndTime && (<span>
                                        <label>to:&nbsp;</label>
                                        <span>{ t.availableEndTime }</span>
                                    </span>) }
                                </div>
                            ));
                        }
                    }
                },
                {
                    path: "whenHandedOver",
                    label: "Handed Over",
                    render: rec => <Date moment={rec.whenHandedOver}/>
                },
                {
                    path: "issued",
                    label: "Issued",
                    raw   : rec => moment(rec.issued).format("MM/DD/YYYY"),
                    render: rec =><Date moment={rec.issued}/>
                },
                {
                    path: "effectiveDateTime",
                    label: "Effective",
                    raw   : rec => moment(rec.effectiveDateTime).format("MM/DD/YYYY"),
                    render: rec => <Date moment={rec.effectiveDateTime}/>
                },
                {
                    path: "assertedDate",
                    label: "Asserted",
                    raw   : rec => rec.assertedDate,
                    render: rec => <Date moment={rec.assertedDate}/>
                }
            ], [
                {
                    path: "meta.lastUpdated",
                    label: "Last Updated",
                    raw   : rec => rec.meta.lastUpdated,
                    render: rec => <Date moment={rec.meta.lastUpdated}/>
                }
            ])
        };
    }

    getSelectionColumnSchema() {
        return {
            label: <div className="text-center">Select</div>,
            render: o => (
                <div className="text-center">
                    <SelectionCheckbox
                        row={o}
                        checked={o.isSelected}
                        onSelectionChange={this.props.onSelectionChange}
                    />
                </div>
            )
        };
    }

        getDownloadColumnSchema() {
            return {
                label: "Download",
                render: o => {

                    const attachment = o?.content?.[0]?.attachment;
                    const hasData = attachment?.data && !attachment?._data;

                    if (!hasData) {
                        return <div className="text-center">-</div>;
                    }

                    return (
                        <div className="text-center">
                            <Tooltip title="Download">
                                <IconButton
                                    size="small"
                                    onClick={() => this.handleDownload(o)}
                                >
                                    <DownloadIcon fontSize="medium" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                }
            };
        }

    /**
     * The idea is to have 3 columns by default:
     * 1. Identifier - something like a name, type, id etc.
     * 2. Details - the important part that will describe the resource
     * 3. Timing - time period, time, age etc.
     * @returns {Array} The generated schema
     */
    determineSchema(sampleResource) {
        if (!sampleResource) {
            return [];
        }

        const columns = [
            this.getSelectionColumnSchema(),
            this.getIdentifierColumnSchema(),
            this.getDetailsColumnSchema(),
            this.getDateColumnSchema()
        ];
        if (isDevOrStage && this.props.type === "DocumentReference") {
            columns.push(this.getDownloadColumnSchema());
        }

        return columns;
    }

    render() {
        const recs = this.props.resources || [];
        const length = recs.length;
        const rows = recs.map(o => o.resource || o);
        const sampleResource = rows[0];

        return (
        <div style={gridStyles.wrapper}>
        <div style={gridStyles.body}>
        <div style={gridStyles.content}>
            <Grid
                rows={rows}
                title={`${length} resource${length === 1 ? "" : "s"} of type ${this.props.type}`}
                cols={this.determineSchema(sampleResource)}
                comparator={(a,b) => {
                    let dA = getSortValue(a);
                    let dB = getSortValue(b);
                    dA = dA ? +moment(dA) : 0;
                    dB = dB ? +moment(dB) : 0;
                    return dB - dA;
                }}
            />
            </div>
        </div>
        </div>
    );
    }
}

